export default __webpack_public_path__ + "static/media/ImgTicket03.632e7bc2.jpg";